// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let fileTypeEnum = {
    'ContainerTestRecord': 0,
    'Invoice': 1,
    'PurchaseOrder': 2,
    'PurchaseRecord': 3,
    'VendorDeclaration': 4
};

export default fileTypeEnum;
